<script lang="ts" setup>
import IconMaterialSymbolsLightArrowDownward from '~icons/material-symbols-light/arrow-downward';

import FloatingCTA from '../FloatingCTA';

interface Props {
	show?: boolean;
	text?: string;
}

withDefaults(defineProps<Props>(), {
	show: true,
	text: 'Imóveis semelhantes'
});

const emit = defineEmits<{
	click: [MouseEvent];
}>();
</script>

<template>
	<Transition name="slide" mode="out-in">
		<div v-if="show" class="flex w-full items-center justify-center">
			<FloatingCTA @click="(event: MouseEvent) => emit('click', event)">
				<template #content>
					<IconMaterialSymbolsLightArrowDownward class="size-5 text-black" />
					<span class="text-base font-medium text-black">{{ text }}</span>
				</template>
			</FloatingCTA>
		</div>
	</Transition>
</template>

<!-- eslint-disable-next-line custom-rules/no-style-tag -->
<style scoped>
.slide-enter-active,
.slide-leave-active {
	transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-enter-from {
	transform: translateY(100%);
	opacity: 0;
}

.slide-leave-to {
	transform: translateY(100%);
	opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
	transform: translateY(0);
	opacity: 1;
}
</style>
